import { ImageElement } from '@typedream/core';
import { getNode, setNodes } from '@udecode/plate-core';
import { Path } from 'slate';
import { DEFAULT_MAX_WIDTH } from '../../../constants';
import { DreamEditor } from '../../../types';

export const changeImage = (
  editor: DreamEditor,
  image: { url: string; width?: number; height?: number },
  options: { at: Path },
) => {
  const node = getNode<ImageElement>(editor, options.at);

  if (node?.type !== 'img') return;

  const adjustDimension = (
    element: ImageElement,
    dimension: {
      width?: number
      height?: number
    },
  ) => {
    const cappedWidth = element.width
      ? element.width
      : Math.min(dimension.width || Infinity, DEFAULT_MAX_WIDTH);
    const cappedHeight = dimension.height && dimension.width
      ? (dimension.height / dimension.width) * cappedWidth
      : element.height;

    const adjusted = {} as typeof dimension;
    if (cappedWidth) adjusted.width = cappedWidth;
    if (cappedHeight) adjusted.height = cappedHeight;

    return adjusted;
  };

  setNodes(
    editor,
    {
      ...image,
      ...adjustDimension(node, image),
    },
    options,
  );
};
